import Header from "../../components/header/header"
import Footer from "../../components/footer/footer"
import Features from "./components/features/features"
import Hero from "./components/hero/hero"
import Info from "./components/info/info"
import pageShell from "../../shared/pageShell.module.css"
import styles from "./agencies-page.module.css"

const AgenciesPage = () => {
	return (
		<div className={`${pageShell.page} ${styles.agencies}`}>
			<Header hideAudienceNav />
			<Hero />

			<Info />

			<Features />

			<Footer />
		</div>
	)
}

export default AgenciesPage
